import { memo } from 'react';
import { Chip, Tooltip } from '@mui/material';
import { getQualityScoreColor, getQualityScoreDescription } from '@/utils/calls';

interface QualityScoreChipProps {
    score: number | null | undefined;
}

/**
 * Displays a color-coded chip for call quality scores.
 * Score is expected to be a percentage value between 0-100.
 *
 * @param {QualityScoreChipProps} props
 * @returns {JSX.Element}
 */
const QualityScoreChip: React.FC<QualityScoreChipProps> = ({ score }) => {
    if (score == null) return null;

    const roundedScore = Math.round(score);
    const tooltipText = getQualityScoreDescription(roundedScore);
    const backgroundColor = getQualityScoreColor(roundedScore, 'light');

    return (
        <Tooltip title={tooltipText} arrow placement="top">
            <Chip
                label={`${roundedScore}%`}
                size="small"
                sx={{
                    minWidth: '80px',
                    px: 1,
                    backgroundColor,
                    color: 'primary',
                }}
            />
        </Tooltip>
    );
};

export default memo(QualityScoreChip);
